import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const TrainingIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M11.204 6.01A2 2 0 0 1 13 8v5h6V8a2 2 0 0 1 1.796-1.99L21 6h2l.204.01A2 2 0 0 1 25 8v2h2l.204.01A2 2 0 0 1 29 12v8l-.01.204a2 2 0 0 1-1.786 1.785L27 22h-2v2l-.01.204a2 2 0 0 1-1.786 1.785L23 26h-2l-.204-.01a2 2 0 0 1-1.785-1.786L19 24v-5h-6v5l-.01.204a2 2 0 0 1-1.786 1.785L11 26H9l-.204-.01a2 2 0 0 1-1.785-1.786L7 24v-2H5l-.204-.01a2 2 0 0 1-1.785-1.786L3 20v-8a2 2 0 0 1 1.796-1.99L5 10h2V8a2 2 0 0 1 1.796-1.99L9 6h2l.204.01ZM9 24h2V8H9v16Zm12 0h2V8h-2v16ZM5 20h2v-8H5v8Zm20 0h2v-8h-2v8Zm-12-3h6v-2h-6v2Z" />
  </BaseIcon>
);
